export default __webpack_public_path__ + "static/media/IMG_9772.c07bad66.JPG";